import { AirplaneInFlight } from "@phosphor-icons/react";

/**
 * Shared decorative backdrop for the international-v2 flight pages
 * (results, review) — fills the side gutters on wide screens with soft
 * glows, a faint dashed flight-path, plane silhouettes, and a dimmed
 * "visaro" watermark, so centered `max-w-*` content doesn't sit in a
 * plain gray void. Purely ambient: aria-hidden, pointer-events-none.
 */
const AviationAmbientBackground = () => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
    <div className="absolute top-40 -left-28 size-[28rem] rounded-full bg-visaro-orange/[0.14] blur-3xl" />
    <div className="absolute bottom-10 -right-28 size-[30rem] rounded-full bg-deepBlue/[0.12] blur-3xl" />

    <svg
      className="absolute inset-0 w-full h-full opacity-70"
      preserveAspectRatio="none"
      viewBox="0 0 1600 1200"
      fill="none"
    >
      <path
        d="M -40 260 Q 300 120 800 320 T 1640 200"
        stroke="#94A3B8"
        strokeWidth="2"
        strokeDasharray="2 10"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M -40 980 Q 340 860 800 1020 T 1640 900"
        stroke="#94A3B8"
        strokeWidth="2"
        strokeDasharray="2 10"
        strokeLinecap="round"
        fill="none"
      />
    </svg>

    <AirplaneInFlight
      size={140}
      weight="light"
      className="hidden lg:block absolute top-20 left-8 text-deepBlue/[0.14] rotate-[-18deg]"
    />
    <AirplaneInFlight
      size={112}
      weight="light"
      className="hidden lg:block absolute bottom-20 right-8 text-visaro-orange/[0.18] rotate-[24deg]"
    />
    <AirplaneInFlight
      size={68}
      weight="light"
      className="hidden xl:block absolute top-[45%] right-12 text-deepBlue/[0.12] rotate-[10deg]"
    />
    <AirplaneInFlight
      size={56}
      weight="light"
      className="hidden xl:block absolute bottom-[30%] left-12 text-visaro-orange/[0.12] rotate-[-8deg]"
    />

    <span
      className="hidden lg:block absolute top-16 -right-12 font-aeonic font-bold text-deepBlue/[0.06] text-[11rem] xl:text-[13rem] leading-none tracking-tight whitespace-nowrap select-none"
      style={{ writingMode: "vertical-rl" }}
    >
      visaro
    </span>
  </div>
);

export default AviationAmbientBackground;
